import {
  tabCloser,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import RoleActions from '../containers/RoleActions';
import { closeRole } from '../actions';
import RolePanel from '../components/RolePanel';

export default {
  ...tabTemplate('role', RolePanel, matchCodeUrl(['roles']), RoleActions),
  ...tabCloser('closeRoleTab', closeRole),
  access: ({ roles }) => roles.read,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 705,
  dropDownIcon: 'drivers license',
  icon: 'fas fa-id-card',
};
